import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { getPaginatedList } from "../../services/baseServices";
import ExportCSVAsync from "../common/ExportCSVAsync";
import { getFormattedDate } from "../../helper/utils";

const headers = [
	{ label: "Order Id", key: "order_id" },
	{ label: "Created", key: "created_at" },
	{ label: "Completed", key: "completed_at" },
	{ label: "Order Type", key: "order_type" },
	{ label: "Shipping Type", key: "shipping_type" },
	{ label: "Customer", key: "customer_name" },
	{ label: "Phone", key: "phone" },
	{ label: "Before Discount", key: "price_before_discount" },
	{ label: "Discount", key: "discount_amount" },
	{ label: "After Discount", key: "price_after_discount" },
	{ label: "Commission", key: "agent_commission" },
	{ label: "Sent to Agent", key: "commission_sent" },
];

const loadData = (item) => {
	return {
		order_id: item.order_id,
		created_at: getFormattedDate(item.created_at, 'DD-MM-YYYY'),
		completed_at: getFormattedDate(item.completed_at, 'DD-MM-YYYY'),
		order_type: item.order_type,
		shipping_type: item.shipping_type,
		customer_name: item.customer_name,
		phone: item.phone,
		price_before_discount: item.price_before_discount,
		discount_amount: item.discount_amount,
		price_after_discount: item.price_after_discount,
		agent_commission: item.agent_commission,
		commission_sent: item.commission_sent?"YES": "NO",
	};
};

class AgentCommission extends Component {
	constructor() {
		super();
		this.state = {
			agentCommission: [],
			activePage: 1,
			per_page: 15,
			page: 1,
			query_params: {},
			isLoading: true,
		};
	}

	getQueryParams = () => {
		let params = Object.assign(this.state.query_params, {
			per_page: this.state.per_page,
			page: this.state.page,
		});
		return params;
	};

	getAgentCommissions = (params) => {
		getPaginatedList(`distributors/${this.props.match.params.id}/agent_commissions`, params)
			.then((res) => {
				this.setState(
					{
						agentCommission: res.data,
						isLoading: false,
						per_page: res.headers["x-per-page"],
						total_data: parseInt(res.headers["x-total"]),
					},
					() => {}
				);
			})
			.catch((errMsg) => {
				console.log("Error Message: ", errMsg);
			});
	};

	componentDidMount() {
		this.setState({ query_params: this.props.queryParams }, () => {
			this.getAgentCommissions(this.getQueryParams());
		})
	}

	handlePageChange = (pageNumber) => {
		this.setState({ page: pageNumber, activePage: pageNumber }, () => {
			this.getAgentCommissions(this.getQueryParams());
		});
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.queryParams.month.toString() !== this.props.queryParams.month.toString() 
            || prevProps.queryParams.year.toString() !== this.props.queryParams.year.toString() || this.props.refresh) {
			this.setState({ query_params: this.props.queryParams }, () => {
            	this.getAgentCommissions(this.getQueryParams());
			})
        }
	}

	render() {
		return (
		<div className="main-content">
			<div className="page-header">
				<h2 className="page-title">Agent Commissions</h2>
				<div className="ml-auto" style={{display: "flex"}}>
					<ExportCSVAsync
						fileName={"Agent-Commission-"+getFormattedDate(new Date(),"DD-MM-YYYY")+".csv"}
						Url={`distributors/${this.props.match.params.id}/agent_commissions`}
						headers={headers}
						loadData={loadData}
						params={{month: this.props.queryParams?.month, year: this.props.queryParams?.year, skip_pagination: true}}
						title="Agent Commission"/>

				</div>
			</div>
			<table className="order-table table table-striped">
				<thead>
					<tr>
						<th style={{width: '20px'}}>Order Id</th>
						<th>Created</th>
						<th>Completed</th>
						<th>Type</th>
						<th>Shipping</th>
						{/* <th>Customer</th>
						<th>Phone</th> */}
						<th>Before Discount</th>
						<th>Discount</th>
						<th>After Discount</th>
						<th>Commission</th>
						<th>Sent</th>
					</tr>
				</thead>
				<tbody>
					{this.state.agentCommission?.length > 0 &&
					this.state.agentCommission?.map((ac, index) => {
						return (
							<tr key={index}>
								<td>{ac.order_id}</td>
								<td>{getFormattedDate(ac.created_at, "DD-MM-YYYY")}</td>
								<td>{getFormattedDate(ac.completed_at, "DD-MM-YYYY")}</td>
								<td>{ac.order_type}</td>
								<td>{ac.shipping_type}</td>
								{/* <td>{ac.customer_name}</td>
								<td>{ac.phone}</td> */}
								<td>{ac.price_before_discount}</td>
								<td>{ac.discount_amount}</td>
								<td>{ac.price_after_discount}</td>
								<td>{ac.agent_commission}</td>
								<td>{ac.commission_sent?"Yes":"No"}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<div className="mt-3">
				<Pagination
					itemClass="page-item"
					linkClass="page-link"
					activePage={this.state.activePage}
					itemsCountPerPage={parseInt(this.state.per_page)}
					totalItemsCount={parseInt(this.state.total_data)}
					pageRangeDisplayed={10}
					onChange={this.handlePageChange.bind(this)}
				/>
			</div>
		</div>
		);
	}
}

export default withRouter(AgentCommission);
